import React from "react";
import Styles from "./ReviewCard.module.css";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import quotationMark from "../../../../assets/Images/quotationMark.png";

function ReviewCard({ userName, userGuideRate, comment }) {
	const stars = [1, 2, 3, 4, 5];
	return (
		<div className={Styles.cardContainer}>
			<img
				className={Styles.quotationMark}
				src={quotationMark}
				alt='quotation Mark'
			/>
			<p className={Styles.comment}>{comment}</p>

			<div className={Styles.userName}>{userName}</div>
			<p className={Styles.rate}>
				{stars.map((star) => (
					<span
						key={star}
						className={
							star <= userGuideRate
								? `${Styles.star} ${Styles.filled}`
								: Styles.star
						}
					>
						<StarRoundedIcon fontSize='large' />
					</span>
				))}
			</p>
		</div>
	);
}

export default ReviewCard;
